// Promotion-Hook + Komponenten für Herbst-Aktion
// Aktualisiert sich alle 60 s via Fetch + lokaler Countdown jede Sekunde.
import { useEffect, useRef, useState, useCallback } from "react";
import api from "./api";

const CACHE_KEY = "__promo_cache_v1";

export function usePromotion() {
  const [data, setData] = useState(() => {
    try {
      const raw = sessionStorage.getItem(CACHE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch { return null; }
  });
  const [left, setLeft] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const r = await api.get("/public/promotion");
        if (cancelled) return;
        setData(r.data);
        sessionStorage.setItem(CACHE_KEY, JSON.stringify(r.data));
        try { localStorage.setItem("fbv_promo_active_v1", r.data?.active ? "1" : "0"); } catch { /* noop */ }
      } catch (e) { /* silent */ }
    };
    load();
    const t = setInterval(load, 60_000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  // lokale Sekunden-Uhr (seit letztem Server-Sync)
  const syncedAtRef = useRef({ at: 0, left: 0 });
  useEffect(() => {
    if (!data) return;
    syncedAtRef.current = { at: Date.now(), left: data.seconds_left || 0 };
    setLeft(data.seconds_left || 0);
    const t = setInterval(() => {
      const elapsed = Math.floor((Date.now() - syncedAtRef.current.at) / 1000);
      const next = Math.max(0, syncedAtRef.current.left - elapsed);
      setLeft(next);
    }, 1000);
    return () => clearInterval(t);
  }, [data?.seconds_left, data?.server_now]);

  // Beim ersten Zeichnen ist „left“ noch 0: dann die Restzeit aus den Daten nehmen, sonst springt die Seite (CLS)
  const remaining = left > 0 ? left : (data?.seconds_left || 0);
  return { promo: data, secondsLeft: remaining, active: !!(data?.active && remaining > 0), loaded: data !== null };
}

/** Letzter bekannter Stand (gerätebezogen): war beim letzten Besuch eine Aktion aktiv? Standard: ja. */
export function promoProbablyActive() {
  try { return localStorage.getItem("fbv_promo_active_v1") !== "0"; } catch { return true; }
}

export function splitDHMS(totalSeconds) {
  const s = Math.max(0, totalSeconds | 0);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return { d, h, m, s: sec };
}

export function fmtEur(n) {
  return `${(n ?? 0).toLocaleString("de-DE", { minimumFractionDigits: 0, maximumFractionDigits: 0 })} €`;
}

export function trackPromo(event, product_slug, source) {
  try {
    api.post("/public/promotion/track", { event, product_slug, source }).catch(() => {});
  } catch { /* noop */ }
}

export function usePromoTrack() {
  return useCallback(trackPromo, []);
}
